import { STOREFRONT_GATEWAY_IDS } from './gatewayIds';

/**
 * Lists gateways connected on the company profile, scoped to the public storefront.
 */
export function resolveStorefrontPaymentGateways(companyData = {}) {
  const gateways = [];

  const deluxeActive = Boolean(companyData.deluxe?.connection?.connected === true);
  if (deluxeActive) {
    gateways.push({
      id: STOREFRONT_GATEWAY_IDS.deluxe,
      label: 'Card (Deluxe)',
      supportsStorefrontCheckout: true,
    });
  }

  return gateways;
}

export function storefrontHasOnlineCheckout(gateways) {
  return Array.isArray(gateways) && gateways.some((g) => g.supportsStorefrontCheckout);
}

export function computeStorefrontBookingTotal(service, selectedPackage, selectedAddons = []) {
  if (!service) return 0;
  const base = selectedPackage
    ? Number(selectedPackage.price) || 0
    : Number(service.price) || 0;
  let total = base;
  (selectedAddons || []).forEach((addon) => {
    total += Number(addon.price) || 0;
  });
  return total;
}
